import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, isDevMode, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';

// for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';
// for Redux use:
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ROOT_EFFECTS, ROOT_REDUCERS } from './core/states/app.state';

import { AppComponent } from './app.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { DEFAULT_GLOBAL_TOASTR_CONFIG } from './core/helpers/ui/ui.constant';
import { AUTH_TOKEN_INTERCEPTOR_PROVIDERS } from './core/interceptors/auth-token.interceptor';
import { ERROR_INTERCEPTOR_PROVIDERS } from './core/interceptors/http-error.interceptor';
import { EncryptionService } from './core/services/ui/encryption.service';
import { DEVICE_TOKEN_INTERCEPTOR_PROVIDERS } from './core/interceptors/device-token.interceptor';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    OverlayModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    ToastrModule.forRoot(DEFAULT_GLOBAL_TOASTR_CONFIG),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),

    // for HttpClient use:
    LoadingBarHttpClientModule,
    // for Router use:
    LoadingBarRouterModule,
    // for Core use:
    LoadingBarModule,
    // for Redus use:
    StoreModule.forRoot(ROOT_REDUCERS),
    EffectsModule.forRoot(ROOT_EFFECTS),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (svc: EncryptionService) => () => svc.loadPublicKey(),
      deps: [EncryptionService],
      multi: true,
    },
    AUTH_TOKEN_INTERCEPTOR_PROVIDERS,
    ERROR_INTERCEPTOR_PROVIDERS,
    DEVICE_TOKEN_INTERCEPTOR_PROVIDERS,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
